import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitoaurangabadcab() {



    const cardData = {

keyword: "Mumbai to Aurangabad Cab",

headingDescription:
    "Mumbai Airport Cab offers safe, comfortable, and reliable Mumbai to Aurangabad Cab services for family vacations, business travel, pilgrimage tours, heritage sightseeing, and outstation journeys. We provide well-maintained Sedan, SUV, Innova Crysta, Ertiga, Tempo Traveller, Luxury Urbania, and Mini Bus options with experienced chauffeurs for a smooth highway journey. With doorstep pickup across Mumbai, Mumbai Airport transfers, one-way and round-trip cab bookings, flexible travel plans, 24/7 customer support, and transparent pricing, we ensure a convenient and enjoyable road trip to Chhatrapati Sambhajinagar (Aurangabad), a city renowned for its UNESCO World Heritage Sites, historical monuments, and spiritual destinations.",

topPlaces: [
    {
        title: "Ajanta Caves",
        description:
            "Ajanta Caves are among India's most treasured UNESCO World Heritage Sites, featuring ancient Buddhist rock-cut caves that date back more than two thousand years. The caves are famous for their magnificent murals, sculptures, monasteries, and prayer halls that reflect exceptional craftsmanship and artistic excellence. Visitors from around the world explore these historic monuments to admire their architecture, learn about Buddhist culture, and experience one of Maharashtra's greatest archaeological wonders."
    },
    {
        title: "Ellora Caves",
        description:
            "Ellora Caves are a UNESCO World Heritage Site showcasing an extraordinary collection of Buddhist, Hindu, and Jain rock-cut temples and monasteries. The magnificent Kailasa Temple, carved from a single rock, is one of the world's greatest architectural achievements. Tourists enjoy exploring the detailed carvings, ancient sculptures, and centuries of history that make Ellora one of India's most remarkable heritage destinations."
    },
    {
        title: "Grishneshwar Jyotirlinga",
        description:
            "Grishneshwar Temple is one of the twelve sacred Jyotirlingas dedicated to Lord Shiva and is an important pilgrimage destination near Aurangabad. The temple is admired for its beautiful stone architecture, intricate carvings, and peaceful spiritual atmosphere. Devotees from across the country visit to seek blessings and often combine the temple with an Ellora Caves tour."
    },
    {
        title: "Bibi Ka Maqbara",
        description:
            "Bibi Ka Maqbara is one of Aurangabad's most famous landmarks and is often referred to as the 'Mini Taj Mahal.' Built by Prince Azam Shah in memory of his mother, the monument features elegant Mughal architecture, landscaped gardens, and impressive marble work. Visitors appreciate its historical significance and picturesque setting for sightseeing and photography."
    },
    {
        title: "Daulatabad Fort",
        description:
            "Daulatabad Fort is an ancient hill fort known for its strategic design, massive defensive walls, and remarkable engineering. The fort has witnessed the rule of several dynasties and offers visitors an opportunity to explore underground passages, watchtowers, and historic structures while enjoying panoramic views of the surrounding landscape."
    },
    {
        title: "Panchakki",
        description:
            "Panchakki, meaning water mill, is a fascinating historical monument built using an ingenious medieval water management system. The site includes a beautiful garden, water reservoir, and religious complex that attract visitors interested in history and architecture. The peaceful surroundings make it a pleasant destination for families and tourists exploring Aurangabad."
    },
    {
        title: "Aurangabad Caves",
        description:
            "The Aurangabad Caves are ancient Buddhist rock-cut monuments carved into the hills overlooking the city. These caves feature intricate sculptures, prayer halls, and artistic carvings that showcase the region's rich cultural and religious heritage. Their quiet setting and historical importance make them an interesting stop for history enthusiasts."
    },
    {
        title: "Bhadra Maruti Temple",
        description:
            "Bhadra Maruti Temple is a famous temple dedicated to Lord Hanuman and is unique because the deity is depicted in a reclining posture. Located near Khuldabad, the temple attracts thousands of devotees and is often included in pilgrimage tours covering Ellora and Grishneshwar. The spiritual atmosphere and religious importance make it a significant attraction."
    },
    {
        title: "Khuldabad",
        description:
            "Khuldabad is a historic town known for its ancient gates, Sufi shrines, Mughal monuments, and the simple tomb of Emperor Aurangzeb. The town is an important spiritual and historical destination that reflects the rich cultural heritage of the Deccan region. Visitors often combine Khuldabad with nearby heritage attractions during their Aurangabad trip."
    },
    {
        title: "Jayakwadi Dam and Nath Sagar",
        description:
            "Jayakwadi Dam, built across the Godavari River, forms the vast Nath Sagar reservoir and is one of Maharashtra's largest irrigation projects. The area is known for its scenic beauty, bird sanctuary, and peaceful surroundings that attract nature lovers and photographers. Visitors enjoy relaxing by the water while appreciating the natural landscapes during their Mumbai to Aurangabad cab journey."
    }
],



services: [
{
name: "Mumbai to Aurangabad Cab",
description: "Mumbai Airport Cab provides Mumbai to Aurangabad Cab service for safe, comfortable, and affordable outstation travel. Our fleet includes AC Sedan, Ertiga, Innova Crysta, Kia Carens, SUV, and premium vehicles suitable for family trips, corporate travel, pilgrimage tours, and holiday journeys. We offer one way and round trip cab services with doorstep pickup, professional chauffeurs, transparent pricing, 24x7 booking support, and flexible travel schedules for a smooth journey between Mumbai and Aurangabad."
},
{
name: "Aurangabad to Mumbai One Way Taxi",
description: "Book Aurangabad to Mumbai One Way Taxi with Mumbai Airport Cab for convenient point-to-point travel without return charges. Our clean and well-maintained vehicles, experienced drivers, and fixed fare packages provide a comfortable travel experience for business travellers, tourists, and families."
},
{
name: "Aurangabad to Mumbai Taxi",
description: "Mumbai Airport Cab offers Aurangabad to Mumbai Taxi services with reliable chauffeur-driven vehicles for airport transfers, business trips, family travel, and leisure journeys. Enjoy safe transportation, comfortable seating, and professional customer support throughout your trip."
},
{
name: "One Way Cab Mumbai to Aurangabad",
description: "Choose One Way Cab Mumbai to Aurangabad with Mumbai Airport Cab for affordable intercity travel. We provide AC vehicles, experienced drivers, instant booking, and flexible pickup locations with comfortable travel for individuals, families, and corporate passengers."
},
{
name: "Mumbai to Aurangabad Taxi Fare",
description: "Get the best Mumbai to Aurangabad Taxi Fare with Mumbai Airport Cab through transparent pricing and quality service. We offer economical Sedan options as well as premium SUV and Innova Crysta vehicles with no hidden charges and flexible travel plans."
},
{
name: "Mumbai to Aurangabad Taxi",
description: "Book Mumbai to Aurangabad Taxi for safe and comfortable long-distance travel. Mumbai Airport Cab provides professional chauffeurs, AC vehicles, one way and round trip options, and customized travel packages for every type of traveller."
},
{
name: "Mumbai to Aurangabad One Way Taxi",
description: "Mumbai Airport Cab provides Mumbai to Aurangabad One Way Taxi service for convenient drop journeys with fixed pricing, premium vehicles, and dependable chauffeur service for business and leisure travel."
},
{
name: "Mumbai to Aurangabad Car Rental",
description: "Hire Mumbai to Aurangabad Car Rental with Mumbai Airport Cab and travel in premium chauffeur-driven Sedan, Ertiga, Innova Crysta, Kia Carens, and SUV vehicles. Our service is ideal for family holidays, business travel, and sightseeing tours."
},
{
name: "Mumbai to Aurangabad Cab Booking",
description: "Mumbai Airport Cab offers Mumbai to Aurangabad Cab Booking with instant confirmation, flexible travel schedules, multiple vehicle choices, and 24x7 customer support for hassle-free transportation."
},
{
name: "Mumbai Aurangabad Taxi Service",
description: "Our Mumbai Aurangabad Taxi Service provides dependable intercity travel with comfortable AC vehicles, experienced drivers, and customized one way or round trip packages for families, tourists, and business travellers."
},
{
name: "Mumbai Airport to Aurangabad Taxi",
description: "Book Mumbai Airport to Aurangabad Taxi with Mumbai Airport Cab for direct transfers from domestic and international terminals. We provide flight tracking, luggage assistance, and comfortable chauffeur-driven vehicles."
},
{
name: "Mumbai to Sambhaji Nagar Cab",
description: "Mumbai Airport Cab offers Mumbai to Sambhaji Nagar Cab service with safe long-distance transportation, premium vehicles, and affordable travel packages for personal and business trips."
},
{
name: "Mumbai to Aurangabad Taxi Fare Per Day",
description: "Check Mumbai to Aurangabad Taxi Fare Per Day with Mumbai Airport Cab for transparent pricing and flexible rental packages. Our services are suitable for sightseeing, business meetings, and multi-day tours."
},
{
name: "Navi Mumbai to Aurangabad Cab",
description: "Book Navi Mumbai to Aurangabad Cab with Mumbai Airport Cab for comfortable and reliable outstation travel with professional drivers and premium AC vehicles."
},
{
name: "Thane to Aurangabad Cab",
description: "Mumbai Airport Cab provides Thane to Aurangabad Cab service with doorstep pickup, comfortable seating, and affordable travel options for family, business, and holiday trips."
},
{
name: "Mumbai to Ajanta Ellora Tour Package",
description: "Choose Mumbai to Ajanta Ellora Tour Package with Mumbai Airport Cab for a memorable heritage journey. Our chauffeur-driven vehicles provide comfortable travel to the UNESCO World Heritage Sites with customized sightseeing itineraries and flexible travel plans."
},
{
name: "Mumbai to Paithan Cab Service",
description: "Mumbai Airport Cab offers Mumbai to Paithan Cab Service for pilgrimage travel, family trips, and business visits with AC vehicles, professional chauffeurs, and convenient one way or round trip options."
},
{
name: "Mumbai to Aurangabad MIDC",
description: "Book Mumbai to Aurangabad MIDC Cab with Mumbai Airport Cab for corporate travel and industrial visits. Our punctual drivers and comfortable vehicles ensure efficient transportation for business travellers."
},
{
name: "Mumbai to Sambhajinagar Cab",
description: "Mumbai Airport Cab provides Mumbai to Sambhajinagar Cab service with reliable intercity transportation, premium vehicle options, and flexible travel schedules for families and corporate customers."
},
{
name: "Mumbai to Chhatrapati Sambhajinagar Cab",
description: "Travel with Mumbai to Chhatrapati Sambhajinagar Cab from Mumbai Airport Cab for safe, comfortable, and affordable journeys. Our one way and round trip cab services include Sedan, Ertiga, Innova Crysta, SUV, and luxury vehicles."
},
{
name: "Mumbai to Aurangabad Cab",
description: "Mumbai Airport Cab offers premium Mumbai to Aurangabad Cab services with experienced chauffeurs, comfortable AC vehicles, transparent pricing, and customized travel packages for every travel requirement."
},
{
name: "Mumbai to Aurangabad Taxi",
description: "Book Mumbai to Aurangabad Taxi with Mumbai Airport Cab for dependable long-distance travel, airport transfers, family holidays, business trips, and sightseeing tours with premium comfort."
},
{
name: "Mumbai to Sambhajinagar Taxi Service",
description: "Mumbai Airport Cab provides Mumbai to Sambhajinagar Taxi Service with well-maintained vehicles, trained drivers, affordable fares, and one way or round trip travel packages designed for comfortable intercity transportation."
}
],

tableData: [
["Mumbai to Aurangabad Cab","Aurangabad to Mumbai One Way Taxi"],
["Aurangabad to Mumbai Taxi","One Way Cab Mumbai to Aurangabad"],
["Mumbai to Aurangabad Taxi Fare","Mumbai to Aurangabad Taxi"],
["Mumbai to Aurangabad One Way Taxi","Mumbai to Aurangabad Car Rental"],
["Mumbai to Aurangabad Cab Booking","Mumbai Aurangabad Taxi Service"],
["Mumbai Airport to Aurangabad Taxi","Mumbai to Sambhaji Nagar Cab"],
["Mumbai to Aurangabad Taxi Fare Per Day","Navi Mumbai to Aurangabad Cab"],
["Thane to Aurangabad Cab","Mumbai to Ajanta Ellora Tour Package"],
["Mumbai to Paithan Cab Service","Mumbai to Aurangabad MIDC"],
["Mumbai to Sambhajinagar Cab","Mumbai to Chhatrapati Sambhajinagar Cab"],
["Mumbai to Aurangabad Cab","Mumbai to Aurangabad Taxi"],
["Mumbai to Sambhajinagar Taxi Service",""]
],




whychoose: [
{
WhyChooseheading: "Reliable Mumbai to Aurangabad Cab Service",
WhyChoosedescription: "Mumbai Airport Cab Service offers dependable Mumbai to Aurangabad Cab transportation for business travelers, tourists, families, pilgrims, and corporate clients seeking a comfortable journey."
},
{
WhyChooseheading: "Comfortable Long-Distance Travel Experience",
WhyChoosedescription: "Our cab service provides a smooth and hassle-free travel experience between Mumbai and Aurangabad with clean vehicles and experienced drivers."
},
{
WhyChooseheading: "Ideal for Tourism and Historical Tours",
WhyChoosedescription: "Many travelers choose our Mumbai to Aurangabad Cabs to visit Ajanta Caves, Ellora Caves, Bibi Ka Maqbara, Grishneshwar Jyotirlinga, and other famous attractions."
},
{
WhyChooseheading: "Multiple Vehicle Options Available",
WhyChoosedescription: "Customers can select Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and luxury vehicles according to passenger count and travel preferences."
},
{
WhyChooseheading: "One-Way and Round Trip Facilities",
WhyChoosedescription: "Whether you require a one-way transfer, same-day return, round trip, or customized itinerary, we provide flexible booking solutions."
},
{
WhyChooseheading: "Pickup Available Across Mumbai",
WhyChoosedescription: "Doorstep pickup services are available from Mumbai Airport, Navi Mumbai, Thane, Andheri, Borivali, Dadar, Bandra, Powai, and nearby locations."
},
{
WhyChooseheading: "Safe and Professional Drivers",
WhyChoosedescription: "Our skilled drivers and regularly maintained vehicles ensure a safe, comfortable, and stress-free journey throughout your travel."
},
{
WhyChooseheading: "Suitable for Family and Group Travel",
WhyChoosedescription: "From solo travelers to large groups, we provide suitable vehicle options for vacations, pilgrimage tours, family functions, and corporate travel."
}
]
};

const faqData = [
{
question: "Why do travelers book Mumbai to Aurangabad Cabs?",
answer: "Aurangabad is famous for Ajanta and Ellora Caves, Grishneshwar Jyotirlinga, Bibi Ka Maqbara, historical monuments, and business activities."
},
{
question: "Can I book a one-way cab from Mumbai to Aurangabad?",
answer: "Yes, one-way cab services are available along with round-trip and customized travel packages."
},
{
question: "Which vehicle is suitable for Mumbai to Aurangabad travel?",
answer: "Sedan cars, Ertiga, and Innova Crysta are among the most preferred vehicles due to their comfort and spacious seating."
},
{
question: "Are same-day return trips available?",
answer: "Yes, customers can choose same-day return travel depending on their schedule and travel requirements."
},
{
question: "Can families use this service for sightseeing trips?",
answer: "Yes, families frequently book Mumbai to Aurangabad Cabs for vacations, historical tours, and religious visits."
},
{
question: "Do you provide Tempo Travellers for group travel?",
answer: "Yes, Tempo Travellers and larger vehicles are available for family tours, pilgrimage groups, and corporate outings."
},
{
question: "Can customers start the journey from Mumbai Airport?",
answer: "Yes, pickup services are available from Mumbai Airport, railway stations, hotels, offices, and residential locations."
},
{
question: "Is advance reservation recommended for Mumbai to Aurangabad travel?",
answer: "Yes, advance booking helps secure preferred vehicles and ensures smooth travel planning."
},
{
question: "Can sightseeing locations be included during the trip?",
answer: "Yes, customers can customize their itinerary and include Ajanta Caves, Ellora Caves, Grishneshwar Temple, Daulatabad Fort, and other attractions."
},
{
question: "How can I book a Mumbai to Aurangabad Cab?",
answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cab Service."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Abhishek Jadhav",
feedback:
"I booked a Mumbai to Aurangabad Cab for a family trip to Ajanta and Ellora Caves. The vehicle was comfortable, the driver was professional, and the journey was excellent.",
rating: 5
},
{
id: 2,
name: "Mrs. Shweta Patil",
feedback:
"Our visit to Grishneshwar Jyotirlinga and Aurangabad attractions was very convenient with Mumbai Airport Cab Service. The cab was clean, punctual, and the entire trip was well managed.",
rating: 5
}
];





























   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];










const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Mumbai to Aurangabad Cab",
"image": "https://www.mumbaiairportcabs.com/assets/images/mumbai-to-aurangabad-cab.jpg",
"description": "Book Mumbai to Aurangabad cab service for comfortable and affordable travel. Mumbai Airport Cabs provides reliable taxi service with experienced drivers, clean vehicles, transparent pricing, and convenient one-way and round-trip travel options between Mumbai and Aurangabad.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/mumbai-to-aurangabad-cab"
}
};









    return (
        <div>


<Helmet>
  <title>Mumbai to Aurangabad Cab | One Way Taxi Service | +91 9545731161</title>

<meta
 name="description"
 content="Book Mumbai to Aurangabad cab service at affordable fares. Safe and reliable taxi service with professional drivers, one-way and round-trip options, and comfortable travel between Mumbai and Aurangabad."
/>

<meta
 name="keywords"
 content="mumbai to aurangabad cab, aurangabad to mumbai one way taxi, aurangabad to mumbai taxi, one way cab mumbai to aurangabad, mumbai to aurangabad taxi fare, mumbai to aurangabad taxi, mumbai aurangabad cab service, mumbai to aurangabad car rental, mumbai to aurangabad cab booking, one way taxi mumbai aurangabad, round trip cab mumbai aurangabad, outstation cab mumbai to aurangabad, affordable taxi mumbai to aurangabad, best cab service mumbai to aurangabad, car hire mumbai to aurangabad"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>






            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/107.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitoaurangabadcab;